import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchCertificatsByApprenant = createAsyncThunk(
  "certificats/fetchByApprenant",
  async (apprenantId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/certificats/apprenant/${apprenantId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const genererCertificat = createAsyncThunk(
  "certificats/generer",
  async ({ apprenantId, formationId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/certificats/generer/${apprenantId}/${formationId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur génération");
    }
  }
);

const certificatSlice = createSlice({
  name: "certificats",
  initialState: { list: [], loading: false, error: null, success: null },
  reducers: {
    clearCertificatMessages: (state) => { state.error = null; state.success = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCertificatsByApprenant.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCertificatsByApprenant.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
      })
      .addCase(fetchCertificatsByApprenant.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(genererCertificat.pending,   (state) => { state.loading = true; })
      .addCase(genererCertificat.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
        state.success = "Certificat généré avec succès! 🎓";
      })
      .addCase(genererCertificat.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });
  },
});

export const { clearCertificatMessages } = certificatSlice.actions;
export default certificatSlice.reducer;
